<template>
  <div v-if="show">
    <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
      style="height: auto !important">
      <ul>
        <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
          {{ error }}
        </li>
      </ul>
    </vs-alert>

    <form ref="form" role="form" @submit.stop.prevent="onSubmit">
      <!-- Abas -->
      <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
        <div class="con-ul-tabs">
          <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
            <!-- Dados Gerais -->
            <li class="vs-tabs--li" :class="passo == 0 ? 'activeChild' : ''">
              <button @click="passo = 0" type="button" class="vs-tabs--btn">
                <span>Dados Gerais</span>
              </button>
            </li>

            <!-- Dados de Remessa -->
            <li v-if="formCadastro.tipoCarteira == 'Com Registro'" class="vs-tabs--li"
              :class="passo == 1 ? 'activeChild' : ''">
              <button @click="passo = 1" type="button" class="vs-tabs--btn">
                <span>Dados de Remessa</span>
              </button>
            </li>

            <!-- Dados do Beneficiário -->
            <li v-if="formCadastro.tipoCarteira == 'Com Registro'" class="vs-tabs--li"
              :class="passo == 2 ? 'activeChild' : ''">
              <button @click="passo = 2" type="button" class="vs-tabs--btn">
                <span>Dados do Beneficiário</span>
              </button>
            </li>

            <!-- Dados do Nosso Número -->
            <li v-if="formCadastro.tipoCarteira == 'Com Registro'" class="vs-tabs--li"
              :class="passo == 3 ? 'activeChild' : ''">
              <button @click="passo = 3" type="button" class="vs-tabs--btn">
                <span>Dados do Nosso Número</span>
              </button>
            </li>

            <!-- Dados do Boleto -->
            <li v-if="formCadastro.tipoCarteira == 'Com Registro'" class="vs-tabs--li"
              :class="passo == 4 ? 'activeChild' : ''">
              <button @click="passo = 4" type="button" class="vs-tabs--btn">
                <span>Dados do Boleto</span>
              </button>
            </li>

            <!-- Dados Galaxy Pay -->
            <li v-if="formCadastro.isGalaxyPay" class="vs-tabs--li" :class="passo == 5 ? 'activeChild' : ''">
              <button @click="passo = 5" type="button" class="vs-tabs--btn">
                <span>Dados Galaxy Pay</span>
              </button>
            </li>

            <!-- Dados Pagar.me -->
            <li v-if="formCadastro.isPagarme" class="vs-tabs--li" :class="passo == 7 ? 'activeChild' : ''">
              <button @click="passo = 7" type="button" class="vs-tabs--btn">
                <span>Dados Pagar.me</span>
              </button>
            </li>

            <!-- Dados Trio -->
            <li v-if="formCadastro.isTrio" class="vs-tabs--li" :class="passo == 7 ? 'activeChild' : ''">
              <button @click="passo = 7" type="button" class="vs-tabs--btn">
                <span>Dados Trio</span>
              </button>
            </li>

            <!-- Dados Trio -->
            <li v-if="formCadastro.isParpay" class="vs-tabs--li" :class="passo == 8 ? 'activeChild' : ''">
              <button @click="passo = 8" type="button" class="vs-tabs--btn">
                <span>Dados Parpay</span>
              </button>
            </li>

            <!-- Formas de Pagamento -->
            <li class="vs-tabs--li" :class="passo == 6 ? 'activeChild' : ''">
              <button @click="passo = 6" type="button" class="vs-tabs--btn">
                <span>Formas de Pagamento</span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Dados Gerais -->
      <div :class="passo == 0 ? 'div-show' : 'div-hide'">
        <div class="vx-row my-4">
          <!-- Tipo Carteira -->
          <div class="vx-col w-full">
            <span>Tipo Carteira</span>
            <v-select :options="listTipoCarteira" name="Tipo Carteira" id="Tipo Carteira" label="nomeTipoPagamento"
              v-model="formCadastro.tipoCarteira" @option:selected="selectedTipoCarteira()"
              v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Tipo Carteira'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Tipo Carteira'
                )
                  "></v-select>
          </div>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-input size="large" class="w-full" label-placeholder="Nome Carteira" name="Nome Carteira"
              id="Nome Carteira" :disabled="blockName" v-model="formCadastro.nomeCarteira"
              v-validate="{ required: true, min: 4 }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Carteira'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Nome Carteira'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>

        <div v-if="formCadastro.tipoCarteira == 'Com Registro'" class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select v-if="contas" v-model="formCadastro.idConta" id="Conta" label="Conta" class="select-large w-full"
              name="Conta" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Conta')
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Conta'
                )
                  " @input="selecionaConta()">
              <vs-select-item :key="0" :value="null" :text="'Selecione'" />
              <vs-select-item :key="index + 1" :value="item.id"
                :text="`${item.label} - ${item.outPutLabel.label} (AG${item.agencia} / CC ${item.conta}-${item.digitoConta})`"
                v-for="(item, index) in contas" />
            </vs-select>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-3">
            <vs-checkbox v-model="formCadastro.principal">
              Carteira Principal
            </vs-checkbox>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-3">
            <vs-checkbox v-model="formCadastro.principalFrete">
              Carteira Principal de Frete
            </vs-checkbox>
          </div>
        </div>
      </div>

      <!-- Dados de Remessa -->
      <div v-if="formCadastro.tipoCarteira == 'Com Registro'" :class="passo == 1 ? 'div-show' : 'div-hide'">
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Número Carteira" name="Número Carteira"
              id="Número Carteira" v-model="formCadastro.numeroCarteira" v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Número Carteira'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Número Carteira'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('NumeroConvenio')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Número Convênio" name="Número Convênio"
              id="Número Convênio" v-model="formCadastro.dadosArquivoRemessa.NumeroConvenio"
              v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Número Convênio'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Número Convênio'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('carteira')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Carteira" name="Carteira" id="Carteira"
              v-model="formCadastro.dadosArquivoRemessa.carteira" v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Carteira'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Carteira'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('primeiraInstrucao')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Primeira Instrução" name="Primeira Instrução"
              id="Primeira Instrução" v-model="formCadastro.dadosArquivoRemessa.primeiraInstrucao"
              v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Primeira Instrução'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Primeira Instrução'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('segundaInstrucao')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Segunda Instrução" name="Segunda Instrução"
              id="Segunda Instrução" v-model="formCadastro.dadosArquivoRemessa.segundaInstrucao"
              v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Segunda Instrução'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Segunda Instrução'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
      </div>

      <!-- Dados do Beneficiário -->
      <div v-if="formCadastro.tipoCarteira == 'Com Registro'" :class="passo == 2 ? 'div-show' : 'div-hide'">
        <vs-alert color="primary" title="Atenção!!" active="true" class="my-3" style="height: auto !important">
          O Beneficiário é a pessoa que detém a conta bancária e que receberá o
          dinheiro dos boletos pagos
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col mb-6">
            <span>Utilizar os mesmos dados da Empresa?</span>
            <vs-switch color="success" v-model="formCadastro.dadosBeneficiario.usarDadosEmpresa" style="width: 60px"
              @input="selecionaDadosEmpresa()">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select v-model="formCadastro.dadosBeneficiario.tipo" label="Tipo" class="select-large w-full"
              name="Tipo" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Tipo')
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Tipo'
                )
                  ">
              <vs-select-item :key="index" :value="item.id" :text="item.label" v-for="(item, index) in tiposPessoas" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input v-if="formCadastro.dadosBeneficiario.tipo == 'PJ'" size="large" class="w-full"
              label-placeholder="Razão Social" name="Razão Social" id="Razão Social"
              v-model="formCadastro.dadosBeneficiario.nome" v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Razão Social'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Razão Social'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
            <vs-input v-else size="large" class="w-full" label-placeholder="Nome Completo" name="Nome Completo"
              id="Nome Completo" v-model="formCadastro.dadosBeneficiario.nome" v-validate="{ required: true, min: 6 }"
              :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Completo'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Nome Completo'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input v-if="formCadastro.dadosBeneficiario.tipo == 'PJ'" size="large" class="w-full"
              label-placeholder="CNPJ" name="CNPJ" id="CNPJ" v-model="formCadastro.dadosBeneficiario.cpfcnpj"
              v-validate="{ required: true, min: 18 }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'CNPJ')
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'CNPJ'
                )
                  " v-mask="'##.###.###/####-##'" val-icon-danger="clear" danger-text="Preencha este Campo" />
            <vs-input v-else size="large" class="w-full" label-placeholder="CPF" name="CPF" id="CPF"
              v-model="formCadastro.dadosBeneficiario.cpfcnpj" v-validate="{ required: true, min: 14 }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'CPF')
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'CPF'
                )
                  " v-mask="'###.###.###-##'" val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Endereço" name="Endereço" id="Endereço"
              v-model="formCadastro.dadosBeneficiario.endereco" v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Endereço'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Endereço'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Numero" name="Numero" id="Numero"
              v-model="formCadastro.dadosBeneficiario.numero" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Numero'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Numero'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="bairro" name="bairro" id="bairro"
              v-model="formCadastro.dadosBeneficiario.bairro" v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'bairro'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'bairro'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Cidade" name="Cidade" id="Cidade"
              v-model="formCadastro.dadosBeneficiario.cidade" v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Cidade'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Cidade'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Estado" name="Estado" id="Estado"
              v-model="formCadastro.dadosBeneficiario.estado" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Estado'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Estado'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Cep" name="Cep" id="Cep"
              v-model="formCadastro.dadosBeneficiario.cep" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Cep')
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Cep'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
      </div>

      <!-- Dados do Nosso Número -->
      <div v-if="formCadastro.tipoCarteira == 'Com Registro'" :class="passo == 3 ? 'div-show' : 'div-hide'">
        <vs-alert color="primary" title="Defina o Nosso Número do próximo boleto que será gerado!!" active="true"
          class="my-3" style="height: auto !important">
          O Nosso número é um número atribuído a cada boleto que serve para
          identificar o pagamento quando o dinheiro entrar na conta.<br />
          Esse número deve ser único por boleto bancário gerado para essa
          carteira
        </vs-alert>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select v-model="formCadastro.carteiraJaEmitiuBoletos"
              label="Essa Carteira já foi utilizada para emitir boletos?" class="select-large w-full"
              name="Carteira já Emitiu Boletos" v-validate="{ required: true }" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Carteira já Emitiu Boletos'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Carteira já Emitiu Boletos'
                )
                  ">
              <vs-select-item :key="index" :value="item.id" :text="item.label"
                v-for="(item, index) in utlizacaoBoletos" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Próximo Nosso Número" name="Próximo Nosso Número"
              id="Próximo Nosso Número" type="number" :disabled="formCadastro.carteiraJaEmitiuBoletos == true ? false : true
                " v-model="formCadastro.proximoNossoNumero" v-validate="{ required: true, min_value: 1 }" :state="utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Próximo Nosso Número'
                )
                  " :class="utilsList.validateStateClass(
                    this.veeFields,
                    this.veeErrors,
                    'Próximo Nosso Número'
                  )
                    " val-icon-danger="clear" danger-text="Preencha este Campo" />
          </div>
        </div>
      </div>

      <!-- Dados do Boleto -->
      <div v-if="formCadastro.tipoCarteira == 'Com Registro'" :class="passo == 4 ? 'div-show' : 'div-hide'">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label for="" class="vs-select--label">Multa %</label>

            <money class="w-full vs-inputx vs-input--input large" name="Multa" id="Multa"
              v-model="formCadastro.percentualMulta" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Multa')
                " :danger="!utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Multa'
                )
                  " v-bind="money"></money>
            <small>O Percentual de multa que será aplicado ao valor do boleto em
              caso de atraso do pagamento</small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label for="" class="vs-select--label">Juros (diario)</label>

            <money class="w-full vs-inputx vs-input--input large" name="Juros" id="Juros"
              v-model="formCadastro.percentualJurosDiario" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Juros')
                " :danger="!utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Juros'
                )
                  " v-bind="money"></money>
            <small>O Percentual diário de juros que será aplicado ao valor do boleto
              em caso de atraso</small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Dias para Protesto" name="Dias para Protesto"
              id="Dias para Protesto" type="number" v-model="formCadastro.diasProtesto" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Dias para Protesto'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Dias para Protesto'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" />
            <small>Informe 0 (zero) para não protestar</small>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-textarea label="Instruções para o caixa" v-model="formCadastro.instrucaoCaixa" />
          </div>
        </div>
      </div>

      <!-- Dados Galaxy Pay -->

      <div v-if="formCadastro.isTrio" :class="passo == 7 ? 'div-show' : 'div-hide'">
        <div class="vx-row">
          <div class="vx-col mb-4 mt-4">
            <span>Sandbox</span>
            <vs-switch color="success" v-model="formCadastro.dadosTrio.sandBox" style="width: 60px">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="id da Conta Virtual (SandBox)"
              name="id da Conta Virtual (SandBox)" id="id da Conta Virtual (SandBox)"
              v-model="formCadastro.dadosTrio.idContaVirtual" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'id da Conta Virtual (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'id da Conta Virtual (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="ClientId" name="ClientId" id="ClientId"
              v-model="formCadastro.dadosTrio.ClientId" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'ClientId'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'ClientId'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Secret" name="Secret" id="Secret"
              v-model="formCadastro.dadosTrio.secret" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Secret'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Secret'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="id da Conta Virtual (SandBox)"
              name="id da Conta Virtual (SandBox)" id="id da Conta Virtual (SandBox)"
              v-model="formCadastro.dadosTrio.idContaVirtualSandBox" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'id da Conta Virtual (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'id da Conta Virtual (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="ClientId (SandBox)" name="ClientId (SandBox)"
              id="ClientId (SandBox)" v-model="formCadastro.dadosTrio.sandBoxClientId" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'ClientId (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'ClientId (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosTrio.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Secret (SandBox)" name="Secret (SandBox)"
              id="Secret (SandBox)" v-model="formCadastro.dadosTrio.sandBoxSecret" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Secret (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Secret (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
      </div>


      <div v-if="formCadastro.isParpay" :class="passo == 8 ? 'div-show' : 'div-hide'">
        <div class="vx-row">
          <div class="vx-col mb-4 mt-4">
            <span>Sandbox</span>
            <vs-switch color="success" v-model="formCadastro.dadosParpay.sandBox" style="width: 60px">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Access Token" name="Access Token" id="Access Token"
              v-model="formCadastro.dadosParpay.accessToken" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Access Token'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Access Token'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="xTenant" name="xTenant" id="xTenant"
              v-model="formCadastro.dadosParpay.xTenant" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'xTenant'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'xTenant'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="!formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="xPartnerId" name="xPartnerId" id="xPartnerId"
              v-model="formCadastro.dadosParpay.xPartnerId" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'xPartnerId'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'xPartnerId'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Access Token (SandBox)"
              name="Access Token (SandBox)" id="Access Token (SandBox)"
              v-model="formCadastro.dadosParpay.sandBoxAccessToken" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Access Token (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Access Token (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="xTenant (SandBox)" name="xTenant (SandBox)"
              id="xTenant (SandBox)" v-model="formCadastro.dadosParpay.sandBoxXTenant" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'xTenant (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'xTenant (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosParpay.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="xPartnerId (SandBox)" name="xPartnerId (SandBox)"
              id="xPartnerId (SandBox)" v-model="formCadastro.dadosParpay.sandBoxXPartnerId" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'xPartnerId (SandBox)'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'xPartnerId (SandBox)'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
      </div>

      <!-- Formas de Pagamento -->
      <div :class="passo == 6 ? 'div-show' : 'div-hide'">
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-3 mt-5">
            <span>Formas de Pagamento utilizadas nessa Carteira</span>
            <v-select :options="formasPagamento" name="Formas de Pagamento utilizadas nessa Carteira"
              id="Formas de Pagamento utilizadas nessa Carteira" label="nomeTipoPagamento"
              v-model="formCadastro.formasPagamento" :reduce="(Situacao) => Situacao.idTipoPagamento"
              v-validate="{ required: true }" multiple :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Formas de Pagamento utilizadas nessa Carteira'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Formas de Pagamento utilizadas nessa Carteira'
                )
                  "></v-select>
          </div>
        </div>
      </div>

      <!-- Dados Pagar.me -->
      <div v-if="formCadastro.isPagarme" class="mt-4" :class="passo == 7 ? 'div-show' : 'div-hide'">
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input size="large" class="w-full" label-placeholder="Chave Secreta" name="Chave Secreta"
              id="Chave Secreta" type="text" v-model="formCadastro.dadosPagarme.chaveSecreta" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Chave Secreta'
              )
                " :class="utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'Chave Secreta'
                )
                  " val-icon-danger="clear" danger-text="Preencha este Campo" v-validate="{ required: true }" />
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <BotaoSubmit variant="success" :edit="true" :aguarde="aguardeCadastro" reference="BtnEditar"></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import { Money } from "v-money";

export default {
  props: ["dados"],
  watch: {
    passo: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$validator.validateAll();
      }
    },
    dados(value) {
      if (!value) {
        this.show = false;
        return;
      }

      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),

      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      blockName: false,
      passo: 0,
      contas: [],
      formasPagamento: [],
      aguardeCadastro: false,
      dadosEmpresa: null,
      tiposPessoas: [
        { label: "Selecione", id: null },
        { label: "Pessoa Física", id: "PF" },
        { label: "Pessoa Jurídica", id: "PJ" },
      ],
      utlizacaoBoletos: [
        { label: "Selecione", id: null },
        { label: "Primeira Vez", id: false },
        { label: "Já Emiti Boletos", id: true },
      ],
      dadosBanco: {
        camposObrigatoriosRemessa: "",
      },
      formCadastro: {
        idCarteira: null,
        idConta: null,
        nomeCarteira: "",
        dadosArquivoRemessa: {},
        dadosBeneficiario: {},
        proximoNossoNumero: 1,
        formasPagamento: [],
        tipoCarteira: null,
        isGalaxyPay: false,
        dadosGalaxy: {},
        isPagarme: false,
        dadosPagarme: {},
        principal: false,
        principalFrete: false,
        isTrio: false,
        dadosTrio: {},
        isParpay: false,
        dadosParpay: {},
      },
      show: true,
      listTipoCarteira: ["Com Registro", "Galaxy Pay", "Pagar.me", "Trio", "Parpay"],
    };
  },
  methods: {
    async preencheForm() {
      if (this.dados.idCarteira) {
        this.$validator.pause();
        this.$nextTick(() => {
          this.$validator.errors.clear();
          this.$validator.fields.items.forEach((field) => field.reset());
          this.$validator.fields.items.forEach((field) => {
            if (this.erros) {
              this.errors.remove(field);
            }
          });
          this.$validator.resume();
        });

        this.formCadastro.idCarteira = this.dados.idCarteira;
        this.formCadastro.idConta = this.dados.idConta;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nomeCarteira = this.dados.nomeCarteira;
        this.formCadastro.dadosArquivoRemessa = this.dados.dadosArquivoRemessa;
        this.formCadastro.dadosBeneficiario = this.dados.dadosBeneficiario;
        this.formCadastro.proximoNossoNumero = this.dados.proximoNossoNumero;
        this.formCadastro.percentualMulta = this.dados.percentualMulta;
        this.formCadastro.percentualJurosDiario =
          this.dados.percentualJurosDiario;
        this.formCadastro.numeroCarteira = this.dados.numeroCarteira;
        this.formCadastro.carteiraJaEmitiuBoletos =
          this.dados.carteiraJaEmitiuBoletos;
        this.formCadastro.diasProtesto = this.dados.diasProtesto;
        this.formCadastro.instrucaoCaixa = this.dados.instrucaoCaixa;
        this.formCadastro.tipoCarteira = this.dados.tipoCarteira;

        this.formCadastro.isGalaxyPay = this.dados.isGalaxyPay;
        this.formCadastro.dadosGalaxy = this.dados.dadosGalaxy;

        this.formCadastro.isPagarme = this.dados.isPagarme;
        this.formCadastro.dadosPagarme = this.dados.dadosPagarme;

        this.formCadastro.isTrio = this.dados.isTrio;
        this.formCadastro.dadosTrio = this.dados.dadosTrio;

        this.formCadastro.isParpay = this.dados.isParpay;
        this.formCadastro.dadosParpay = this.dados.dadosParpay;
        console.log(this.dados.dadosParpay);

        this.formCadastro.principal = this.dados.principal;
        this.formCadastro.principalFrete = this.dados.principalFrete;
      } else {
        this.resetForm();
      }

      await this.buscaFormasPagamentoDisponiveis();
      this.selecionaIsGalaxyPayOrIsPagame();

      this.passo = 0;
      this.show = true;
    },
    selecionaDadosEmpresa() {
      if (this.formCadastro.dadosBeneficiario.usarDadosEmpresa) {
        if (this.dadosEmpresa[0].cnpj.length > 14)
          this.formCadastro.dadosBeneficiario.tipo = "PJ";
        else this.formCadastro.dadosBeneficiario.tipo = "PF";

        this.formCadastro.dadosBeneficiario.nome =
          this.dadosEmpresa[0].razaoSocial;
        this.formCadastro.dadosBeneficiario.cpfcnpj = this.dadosEmpresa[0].cnpj;
        this.formCadastro.dadosBeneficiario.endereco =
          this.dadosEmpresa[0].endereco;
        this.formCadastro.dadosBeneficiario.numero =
          this.dadosEmpresa[0].numero;
        this.formCadastro.dadosBeneficiario.bairro =
          this.dadosEmpresa[0].bairro;
        this.formCadastro.dadosBeneficiario.cidade =
          this.dadosEmpresa[0].cidade;
        this.formCadastro.dadosBeneficiario.estado =
          this.dadosEmpresa[0].estado;
        this.formCadastro.dadosBeneficiario.cep = this.dadosEmpresa[0].cep;
      }
    },
    verificaExibicao(tipo) {
      return this.dadosBanco.camposObrigatoriosRemessa.indexOf(tipo) >= 0;
    },

    selecionaIsGalaxyPayOrIsPagame() {
      this.$validator.pause();

      this.blockName = this.formCadastro.tipoCarteira !== "Com Registro";

      //#region Galaxy Pay

      this.formCadastro.nomeCarteira = this.formCadastro.isGalaxyPay
        ? "Galax Pay"
        : this.formCadastro.nomeCarteira;

      this.formCadastro.dadosGalaxy = !this.formCadastro.isGalaxyPay
        ? {}
        : this.formCadastro.dadosGalaxy;

      //#endregion

      //#region Pagar.me

      this.formCadastro.nomeCarteira = this.formCadastro.isPagarme
        ? "Pagar Me"
        : this.formCadastro.nomeCarteira;

      this.formCadastro.dadosPagarme = !this.formCadastro.isPagarme
        ? {}
        : this.formCadastro.dadosPagarme;

      //#endregion

      //#region Trio

      this.formCadastro.nomeCarteira = this.formCadastro.isTrio
        ? "Trio"
        : this.formCadastro.nomeCarteira;

      this.formCadastro.dadosTrio = !this.formCadastro.isTrio
        ? {}
        : this.formCadastro.dadosTrio;

      //#endregion

      //#region Parpay

      this.formCadastro.nomeCarteira = this.formCadastro.isParpay
        ? "Parpay"
        : this.formCadastro.nomeCarteira;

      this.formCadastro.dadosParpay = !this.formCadastro.isParpay
        ? {}
        : this.formCadastro.dadosParpay;

      //#endregion

      this.$validator.reset();
      this.$nextTick(() => {
        this.$validator.resume();
      });
    },
    buscaFormasPagamentoDisponiveis() {
      return new Promise((resolve, reject) => {
        try {
          this.$vs.loading();

          service
            .post(
              "CarteiraCobranca",
              "buscaFormasPagamentoDisponiveis",
              this.formCadastro
            )
            .then((res) => {
              this.formasPagamento = res.data;
              this.formCadastro.formasPagamento = [];
              this.formasPagamento.forEach((element) => {
                if (element.selecionado == 1) {
                  this.formCadastro.formasPagamento.push(
                    element.idTipoPagamento
                  );
                }
              });
              //this.carregando = false;
              this.$vs.loading.close();
              resolve();
            })
            .catch((e) => {
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: e,
                color: "danger",
              });
              this.$vs.loading.close();
              resolve();
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    onSubmit() {
      var action = "Atualizar";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idCarteira) {
        action = "Adicionar";
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.aguardeCadastro = true;
          service
            .post("CarteiraCobranca", action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$emit("concluido");
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: msgRetorno,
                color: "success",
              });
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        idConta: null,
        nomeCarteira: "",
        dadosArquivoRemessa: {},
        dadosBeneficiario: {},
        proximoNossoNumero: null,
        percentualMulta: 0,
        percentualJurosDiario: 0,
        numeroCarteira: "",
        carteiraJaEmitiuBoletos: null,
        diasProtesto: "",
        instrucaoCaixa: "",
        formasPagamento: [],
        tipoCarteira: null,
        isGalaxyPay: false,
        dadosGalaxy: {},
        isPagarme: false,
        dadosPagarme: {},
        isTrio: false,
        dadosTrio: false,
        isParpay: false,
        dadosParpay: false,
        principal: false,
        principalFrete: false,
      };
    },
    onReset() {
      this.$emit("cancel");
      this.resetForm();
    },
    selectedTipoCarteira() {
      this.formCadastro.isGalaxyPay =
        this.formCadastro.tipoCarteira == "Galaxy Pay";

      this.formCadastro.isPagarme =
        this.formCadastro.tipoCarteira == "Pagar.me";

      this.formCadastro.isTrio = this.formCadastro.tipoCarteira == "Trio";

      this.formCadastro.isParpay = this.formCadastro.tipoCarteira == "Parpay";

      this.selecionaIsGalaxyPayOrIsPagame();
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>

<style scoped>
.div-show {
  display: "block";
}

.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>
